module.exports = __webpack_public_path__ + "img/Blob3P.ff6e9977.png";